import setCriticalError from './set-critical-error';
import trackError from './track-error';

export default {
  setCriticalError,
  trackError,
};
